/**
 * 2026-06-07 — Anytime-toggleable player settings strip.
 *
 * Mounted in the scenario-runner header below the drawer toggles. Two
 * switches:
 *
 *   ⚡ Auto-Roll  — when ON, the QuickRollButton on each paragraph
 *                   auto-fires once on mount.
 *   ?  Help     — when ON, the inline "?" affordances next to UI
 *                   elements / charts / tables are visible.
 *
 * Both round-trip through localStorage via playerSettings.ts so the
 * choice persists across reloads.
 */

import './SettingsToggles.css';
import { usePlayerSettings } from '../../services/playerSettings';
import { HelpIcon } from '../help/HelpIcon';

export function SettingsToggles() {
  const {
    autoRollEnabled,
    helpVisibleEnabled,
    setAutoRollEnabled,
    setHelpVisibleEnabled,
  } = usePlayerSettings();

  return (
    <div
      className="br-scenario-settings-toggles"
      data-testid="br-scenario-settings-toggles"
    >
      <button
        type="button"
        className={
          autoRollEnabled
            ? 'br-scenario-settings-toggle br-scenario-settings-toggle-on'
            : 'br-scenario-settings-toggle'
        }
        data-testid="br-scenario-auto-roll-toggle"
        data-state={autoRollEnabled ? 'on' : 'off'}
        aria-pressed={autoRollEnabled}
        onClick={() => setAutoRollEnabled(!autoRollEnabled)}
        title={
          autoRollEnabled
            ? 'Auto-Roll is ON — Quick Roll buttons fire automatically. Click to switch off.'
            : 'Auto-Roll is OFF — click to have rolls happen automatically without a button click.'
        }
      >
        <span aria-hidden="true">⚡</span>
        <span className="br-scenario-settings-label">Auto-Roll</span>
        <span className="br-scenario-settings-state br-label">
          {autoRollEnabled ? 'ON' : 'OFF'}
        </span>
      </button>
      <HelpIcon id="auto-roll" side="below" />
      <button
        type="button"
        className={
          helpVisibleEnabled
            ? 'br-scenario-settings-toggle br-scenario-settings-toggle-on'
            : 'br-scenario-settings-toggle'
        }
        data-testid="br-scenario-help-toggle"
        data-state={helpVisibleEnabled ? 'on' : 'off'}
        aria-pressed={helpVisibleEnabled}
        onClick={() => setHelpVisibleEnabled(!helpVisibleEnabled)}
        title={
          helpVisibleEnabled
            ? 'Help is ON — "?" icons appear next to UI elements. Click to hide them.'
            : 'Help is OFF — click to show "?" icons next to UI elements.'
        }
      >
        <span aria-hidden="true">?</span>
        <span className="br-scenario-settings-label">Help</span>
        <span className="br-scenario-settings-state br-label">
          {helpVisibleEnabled ? 'ON' : 'OFF'}
        </span>
      </button>
    </div>
  );
}

export default SettingsToggles;
